import { theme } from "antd";

/**
 * Bubakii UI Theme Configuration
 * Based on the brand guidelines from cursor.config.json
 */
export const bubakiiTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // Brand Colors
    colorPrimary: "#005249",
    colorPrimaryHover: "#23897A",
    colorPrimaryActive: "#003D35",
    colorPrimaryBg: "#E6F3F1",
    colorPrimaryBgHover: "#CCE7E3",
    colorPrimaryBorder: "#005249",
    colorPrimaryBorderHover: "#23897A",

    // Accent Colors
    colorSuccess: "#5CB85C",
    colorWarning: "#F3B431",
    colorError: "#D9534F",
    colorInfo: "#5BC0DE",

    // Background Colors
    colorBgContainer: "#FFFFFF",
    colorBgLayout: "#F9F9F9",
    colorBgElevated: "#FFFFFF",
    colorBgSpotlight: "#FFFFFF",

    // Text Colors
    colorText: "#2F2F2F",
    colorTextSecondary: "#666666",
    colorTextTertiary: "#999999",
    colorTextQuaternary: "#CCCCCC",

    // Border Colors
    colorBorder: "#CCCCCC",
    colorBorderSecondary: "#E5E5E5",

    // Typography — 16px floor prevents iOS Safari zoom-on-focus for form controls
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    fontWeightStrong: 600,
    fontWeight: 400,

    // Border Radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,

    // Spacing
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    marginMD: 20,
    marginLG: 24,
    marginXL: 32,

    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    paddingMD: 20,
    paddingLG: 24,
    paddingXL: 32,
  },
  components: {
    Button: {
      borderRadius: 8,
      fontWeight: 500,
      controlHeight: 40,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadius: 12,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
    Layout: {
      bodyBg: "#F9F9F9",
      headerBg: "#FFFFFF",
      siderBg: "#FFFFFF",
    },
    Menu: {
      borderRadius: 8,
      itemBorderRadius: 8,
    },
  },
};

/**
 * Bubakii color palette for styled-components
 */
export const colors = {
  primary: "#005249",
  primaryLight: "#23897A",
  accent: "#F3B431",
  background: "#F9F9F9",
  text: "#2F2F2F",
  danger: "#D9534F",
  success: "#5CB85C",
  info: "#5BC0DE",
  white: "#FFFFFF",
  gray: {
    50: "#F9F9F9",
    100: "#F5F5F5",
    200: "#E5E5E5",
    300: "#CCCCCC",
    400: "#999999",
    500: "#666666",
    600: "#2F2F2F",
  },
};

/**
 * Bubakii typography styles
 */
export const typography = {
  fontFamily: "Inter, sans-serif",
  headingWeight: 600,
  textWeight: 400,
  sizes: {
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "30px",
    "4xl": "36px",
  },
};
